module.exports = __webpack_public_path__ + "static/media/7-0.fbd64983.m4a";